// API utility to handle basePath for fetch requests

const BASE_PATH = '/apps/teachme/server';

export function apiUrl(path: string): string {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_PATH}${normalizedPath}`;
}

// Shorthand for common API endpoints
export const API = {
  generateMap: apiUrl('/api/generate-map'),
  teacher: apiUrl('/api/teacher'),
  tts: apiUrl('/api/tts'),
  stt: apiUrl('/api/stt'),
};
